import { IState } from '../../store';
import { selectOffer } from '../offerData';
import { selectIsOfferPublished } from '../offerData/selectIsOfferPublished';
import { selectIsAuctionBankObject } from '../selectIsAuctionBankObject';

export const selectIsUserSubscriptionToPriceChangeEnabled = (state: IState): boolean => {
  const offer = selectOffer(state);
  const subscriptionInfo = !!state.offerData.subscription;
  const isPublished = selectIsOfferPublished(state);
  const isCoworking = !!offer.coworkingOfferType;
  const isAuctionBankObject = selectIsAuctionBankObject(state);

  return isPublished && subscriptionInfo && !isCoworking && !isAuctionBankObject;
};
